import styled from '@emotion/styled';
import { EmotionBreakpoint, useBrandDetails } from 'dw-au-react-components';
import React, { useEffect, useRef, useState } from 'react';
import { PlusIcon, MinusIcon } from '../../svg';
import ShippingCalculator from '../ShippingCalculator/ShippingCalculator';

const StyledAccordion = styled.div`
	.accordion_item {
		padding: 0 0 20px;
		border-bottom: 1px solid #e3e3e3;

		${EmotionBreakpoint('mobile')} {
			border-bottom: none;

			.subtitle {
				font-size: 14px;
				line-height: 20px;
			}
		}

		&.active {
			${EmotionBreakpoint('desktop')} {
				scroll-margin: 120px;
			}

			${EmotionBreakpoint('mobile')} {
				scroll-margin: 150px;
			}
		}

		.question {
			padding: 40px 0 20px;

			${EmotionBreakpoint('mobile')} {
				padding: 20px 0 0;
			}
		}
	}
	.answer_wrapper {
		height: 0;
		overflow: hidden;
		transition: height ease 0.2s;

		&.open {
			height: auto;

			.answer {
				transform: translate(0, 0%);
				transition: all 0.4s ease-in-out;
				opacity: 1;
				animation-delay: 0.2s;
			}
		}

		.answer {
			transform: translate(5%, 0);
			opacity: 0;

			${EmotionBreakpoint('mobile')} {
				padding-top: 20px;
			}

			p {
				color: #545454;
			}

			table {
				margin-bottom: 20px;
			}
		}
	}
`;

function Accordion({ questionData, question }) {
	const contentEl = useRef({});
	const [activeItems, setActiveItems] = useState([]);
	const brandData = useBrandDetails();

	const handleToggle = (slug) => {
		let activeItemsTemp = [...activeItems];
		if (activeItemsTemp.indexOf(slug) > -1) {
			activeItemsTemp = activeItemsTemp.filter((item) => item !== slug);
		} else {
			activeItemsTemp.push(slug);
		}

		setActiveItems(activeItemsTemp);
	};

	useEffect(() => {
		setActiveItems([]);

		if (question) {
			setActiveItems([question]);
			setTimeout(() => {
				goToAnswer(question);
			}, 200);
		}
	}, [question, questionData]);

	const goToAnswer = (question) => {
		const section = document.getElementById('question__' + question);
		section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	return (
		<StyledAccordion>
			{questionData
				?.filter((data) => {
					return (
						data.market !== 'au-vws-only' &&
						(data.market === `${brandData.country.toLowerCase()}-market` ||
							data.market === 'apac-market')
					);
				})
				.map((data, index) => {
					return (
						<div
							key={index}
							data-index={index}
							id={`question__${data.slug}`}
							title={`Click to Expand - ${data.title}`}
							className={`accordion_item ${
								activeItems.indexOf(data.slug) > -1 ? 'active' : ''
							}`}
						>
							<div
								className={`subtitle lower d-flex align-items-center justify-content-between cursor-pointer question ${
									brandData.tag === 'vir' ? 'font-montserrat' : 'roboto'
								}`}
								onClick={() => handleToggle(data.slug)}
							>
								{data.title}
								<span className='control'>
									{activeItems.indexOf(data.slug) > -1 ? (
										<MinusIcon />
									) : (
										<PlusIcon />
									)}
								</span>
							</div>
							<div
								className={`answer_wrapper ${
									activeItems.indexOf(data.slug) > -1 ? 'open' : ''
								}`}
								ref={(element) => (contentEl.current[index] = element)}
								style={
									activeItems.indexOf(data.slug) > -1
										? { height: contentEl?.current[index]?.scrollHeight }
										: { height: '0px' }
								}
							>
								{data.slug === 'estimated-delivery-charges' ? (
									<ShippingCalculator brandData={brandData} />
								) : (
									<div
										className='answer'
										dangerouslySetInnerHTML={{ __html: data.answer }}
									></div>
								)}
							</div>
						</div>
					);
				})}
		</StyledAccordion>
	);
}

export default Accordion;
